import { FC, useState } from "react";
import { NotificationBell } from "widgets/notifications-inbox";
import { TicketThreadModal } from "widgets/support-tickets";

interface Props {
  className?: string;
}

// Связывает inbox и тред тикета: виджеты не импортируют друг друга.
export const HeaderInbox: FC<Props> = ({ className }) => {
  const [ticketId, setTicketId] = useState<number | null>(null);

  return (
    <>
      <NotificationBell className={className} onOpenTicket={setTicketId} />
      {ticketId !== null && (
        <TicketThreadModal
          ticketId={ticketId}
          onClose={() => setTicketId(null)}
        />
      )}
    </>
  );
};
